import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { ChefStoreQrCodeComponent } from './components/chef-store-qr-code/chef-store-qr-code.component';
import { MorePageRoutingModule } from './more-routing.module';
import { MorePage } from './more.page';
import { QRCodeModule } from 'angularx-qrcode';
import { InviteNewUserService } from '@shared/services/invite-new-user/invite-new-user.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MorePageRoutingModule,
    SharedModule,
    TranslateModule,
    QRCodeModule,
  ],
  declarations: [MorePage, ChefStoreQrCodeComponent],
  providers: [InviteNewUserService],
})
export class MorePageModule {}
